<template>
    <div class="background--paper divider--container py-5">
        <div class="divider-white--top"></div>
        <div class="container mx-auto flex flex-wrap">
            <div class="w-full md:w-2/5 pt-4">
                <div class="w-4/5 mx-auto pb-12 pd:mb-0">
                    <frequency-selection/>
                </div>
                <div class="w-4/5 mx-auto">
                    <number-of-months-selector/>
                </div>
            </div>
            <div class="w-full md:w-3/5">
                <deliveries-summary></deliveries-summary>
            </div>
            <div class="divider-white--bottom"></div>
        </div>
    </div>
</template>

<script>
import DeliveriesSummary from '@/components/partials/account/gifting/numberOfDeliveries/DeliveriesSummary';
import FrequencySelection from '@/components/partials/account/gifting/numberOfDeliveries/FrequencySelection';
import NumberOfMonthsSelector from '@/components/partials/account/gifting/numberOfDeliveries/NumberOfMonthsSelector';

export default {
    name: 'NumberOfDeliveries',
    components: {
        DeliveriesSummary,
        FrequencySelection,
        NumberOfMonthsSelector,
    },
};
</script>
